export const blockIconsTransportationAgricultureNew = (
	<span className='material-symbols-outlined'>agriculture</span>
);
